import React from "react";
import axios from 'axios';
import Breadcrumb from '../Components/Breadcrumb';
//import { Link } from 'react-router-dom';
import './Orderdetails.css';
import './Myorders.css';
import { useParams } from "react-router-dom";
//import { withRouter } from "react-router";
//import Complaintitem from '../Pop-up/Complaintitem';
//import Breadcrum from '../Components/Breadcrum';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AuthService from '../Services/auth.service';
import Moment from 'react-moment';
import Loader from "../Components/Loader";
import toast, { Toaster } from 'react-hot-toast';
//import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
//import Recentissue from '../Pop-up/Recentissue';
class Orderdetails extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            //cats : [],
            menu :[],
            rate :[],
            wallet :[],
            modal_large: false,
            showSignup:false,
            showOtp:false,
            setPop:false,
            showRegister:false,
            showLogin:true,
            showOTP:false,
            redirect:false,
            loading:'',
            uName:undefined,
            uMobile:undefined,
            uEmail:undefined,
            uNew:false,
            mmenu:'collapse navbar-collapse ',
            toggle:false,
            check:false,
            toggleLeft:false,
            toggleRight:false,
            mmRight:'collapse',
            mmLeft:'collapse',
            modal: false,modal1:false,
      name: "",
      modalInputName: "",
      profile:[],
      address:[],
      cats : [],issue:[],raise:[],id:[],current:[],Order:[],loader:true
        }
       /*  this.tog_large = this.tog_large.bind(this); */
    
    }
 componentDidMount(){
this.getData()
 }

 getData(){
        
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
           //alert(USR_TOKEN)
            const user = AuthService.getCurrentUser();
            this.setState({profile:user})
            const  {order}  = this.props.params ;
    axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.get_order?name='+order,{
        headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
    })
    .then(response=>{
        this.setState({Order:order})
        this.setState({menu:response.data['message']})
        this.setState({rate:response.data['message']['items']})
        //console.log(response.data['message'])
        this.setState({loader:false})
    })
    .catch(response=>{
        this.setState({loader:false})
    })
    axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.wallet_balance',{
        headers : {'Authorization' : USR_TOKEN,'content-type': 'application/json'}
    })
    .then(response=>{
        this.setState({wallet:response.data['message']})
        //console.log(response.data['message'])
    })
    axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.issue_list',{
        headers : {'Authorization' : USR_TOKEN,'content-type': 'application/json'}
    })
    .then(response=>{
        this.setState({issue:response.data['message']})
        //console.log(response.data['message'])
    })
    axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.raised_issues?order_id='+order,{
        headers : {'Authorization' : USR_TOKEN,'content-type': 'application/json'}
    })
    .then(response=>{
        this.setState({raise:response.data['message']})
       // console.log(response.data['message'])
    })
    }
    else{
    //alert("Not Logged in")
    toast.error("Not Logged in")
    }
    }
     tog_large() {

       
    
    
            this.setState(prevState => ({
                modal: !prevState.modal
            }));
    
            this.setState(prevState => ({
                modal1: !prevState.modal1
            }));
      
        
    } 
    handleCancel = () => {
        this.tog_large()
    }
    handleSubmit2(e) {
        this.setState({ name: this.state.modalInputName });
        this.modalClose();
      }
    
      modalOpen= Item =>{
        this.setState({ modal: true });
        this.setState({ current:Item });
      }
    
      modalClose() {
        this.setState({
          modal_large: false
        });
    }



   
    handleOpen= Name =>{
        this.setState({ modal1: true });
        this.setState({ id:Name });
    }
    /* handleClose  = () => {
        this.tog_large()
    } */

    /* showRegister = () => {
        this.hideAll()
        this.setState({showRegister:true})
        
    }
    handleMobile = () => {
        this.hideAll()
        this.setState({showSignup:true})
       
    }
    handleCancel = () => {
        this.tog_large()
        this.hideAll()
        this.setState({showLogin:true})
    } */



    handleSubmit = event => {
  
        const cancelData= {
        name:event
        }
        
        const USR_TOKEN = localStorage.getItem("userToken")
          if(USR_TOKEN){
             //alert(USR_TOKEN)
              const user =  AuthService.getCurrentUser();
              this.setState({profile:user})
              this.setState({value:true})
                axios.post(process.env.REACT_APP_API_URL+'api/method/ecom.api.cancel_order',cancelData,{
                headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
                
                })      
                .then(  
                    res =>{
                       //alert("cancelled")
                       // this.setState({value:true})
                       // window.location.href = "/my-orders.html"; 
                       this.getData(this.state.Order)
                        } 
                )
                .catch(
                    err =>{
                        alert("failed")
                    }
                )
          }
          else{
            alert("Not Logged in")
        }

        /* if(this.state.value){
            alert("success")
            window.location.href = "/my-account.html";

        } 
        else{
            alert("failed")
        }       */
            
        
      }






  render() {
      //alert(this.state.menu.name)
    return this.state.loader ? <Loader/> :<div>
        <Breadcrumb head="My Order" group={this.state.menu.status} url="/my-orders"/>
        <Toaster
            position="top-center"
            reverseOrder={false}
        />
    <div className="container mb-5">
    
        <div className="row mt-3">
            <div className="col-md-4">

            <h2><a href="/my-orders" type="button"><ArrowBackIcon className="mr-2 go-back"/></a>My Orders</h2>

            

            </div>
            <div className=" col-md-12 mt-2">
                <div>
                <p className="opacity-header">Ordered on&nbsp;<Moment format="DD MMMM yyyy" withTitle>{this.state.menu.transaction_date}</Moment></p>
                    <h4 className={this.state.menu.status==='Cancelled' ? 'cancel-delivery mt-2' : 'delivery-today mt-2' }>{this.state.menu.status} </h4>
                    
                    <ul className="subtotal bottom-line subtotal-list subtotal ">
                    {this.state.rate.map((itm,k)=>{
            return(				
                    <li className=" float-price-right col-12" key={k}><img src={process.env.REACT_APP_API_URL +itm.image} className="product-thumbnails" alt=""/><p className="itm ">{itm.item_name} x {itm.qty}</p> <span className="itm">Rs{itm.net_rate}</span></li>
                    )
                    })}
                    </ul>
                </div>
                
                <div>
                    <ul className="subtotal-list ">
                        <li className="float-price-right total-price-small sub-total mt-2">Sub-Total<span className="sub-total">Rs {this.state.menu.billed_amt}</span></li>
                        <li className="float-price-right total-price-small sub-total mt-2">Delivery charges<span className="sub-total ">Rs {this.state.menu.base_total_taxes_and_charges}</span></li>
                        {/* <li className="float-price-right total-price-small sub-total mt-2">Wallet<span className="sub-total ">Rs&nbsp;{this.state.wallet.balance}</span></li> */}
                        <li className=" float-price-right total-price col-12">Total<p className="per-delivery ">&nbsp;(per delivery)</p><span className=" ">Rs {this.state.menu.grand_total}</span></li>
                    </ul>
  
{/*                     {this.state.menu.status === 'To Deliver and Bill' || this.state.menu.status === 'To Deliver' ? <button className="ordr-cncl"  onClick={(event) => {if(window.confirm(' Are You Sure To Cancel the Order?')){this.handleSubmit(this.state.menu.name)};}}>Cancel Order <ArrowForwardIcon/>  </button> :'' }
 */}                </div>
                <br/>
                {/* <div>
                <p className="opacity-header">Ordered on 1september 2021 at 6.00pm </p>
                    <h4 className="delivery-today mt-1">Delivered Today,  02th at 4:00pm</h4>
                    
                    <ul className="subtotal bottom-line subtotal-list subtotal ">
                    <li className=" float-price-right "><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1 </p> <span className="itm">$10</span></li>
                    <li className=" float-price-right "><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1 </p> <span className="itm">$10</span></li>
                    <li className=" float-price-right "><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1 </p> <span className="itm">$10</span></li>
                    <li className=" float-price-right "><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1 </p> <span className="itm">$10</span></li>
                    </ul>
                </div>
                
                <div>
                    <ul className="subtotal-list ">
                        <li className="float-price-right total-price-small sub-total ">Sub-Total<span className="sub-total">Rs 40</span></li>
                        <li className="float-price-right total-price-small sub-total ">Discount<span className="sub-total ">Rs 10</span></li>
                        <li className="float-price-right total-price-small sub-total">Wallet<span className="sub-total ">Rs 0</span></li>
                        <li className=" float-price-right total-price ">Total<p className="per-delivery ">&nbsp;(per delivery)</p><span className=" ">Rs 30</span></li>
                    </ul>
                </div>
                <br/> */}
                {/* <div>
                  <h3>Order Options</h3>
                  <Link to="/package-issue.html"><button type="button" className=" add-to-cart2 btnn mb-3" onclick="/package-issue.html">Need Help?&nbsp;→</button></Link>
                    
                </div> */}
                {/*<div>
                  <h3>Need Help?</h3>
                  
                    <ul className="subtotal-list ml-2">
                         <Modal
                                size="lg"
                                isOpen={this.state.modal}
                               
                                show={this.state.modal}
                               
                            >
                            <ModalHeader toggle={() => this.setState({ modal: false })}>
                            </ModalHeader>
                            <ModalBody>
                                    <Complaintitem  modalClose={this.modalClose} handleCancel={this.handleCancel} head={this.state.rate} pass={this.state.menu.name} issue={this.state.current}/>

                            </ModalBody>
                          
                         </Modal>

                            {this.state.issue.map((itms,s)=>{
                            return(	
                        <li className=" mrn-btm" key={s}> <p className="green-link per-defined"><a href="#" onClick={(Item) => this.modalOpen(itms.name,s)}>{itms.name} </a></p></li>
                        )
                    })}
                    </ul>
                </div>*/}
                {/*<div>
                <h3> Recent issue</h3>
                  
                    <ul className="subtotal-list ml-2">
                    <Modal
                                size="lg"
                                isOpen={this.state.modal1}
                               
                                show={this.state.modal1}
                               
                            >
                            <ModalHeader toggle={() => this.setState({ modal1: false })}>
                            </ModalHeader>
                            <ModalBody>
                                    <Recentissue   handleCancel={this.handleCancel} id={this.state.id}/>

                            </ModalBody>
                          
                    </Modal>
                    {this.state.raise.map((itmss,p)=>{
                        
                        return(	
                        <li className="mrn-btm " key={p}> <p className="green-link per-defined"><a href="#" onClick={(Name) => this.handleOpen(itmss.name,p)}>{itmss.subject} </a></p></li>
                        )
                    })} 
                    </ul>
                </div> */}
            </div>
            {/* <div>
                <h1></h1> 
            </div> */}
        </div>
  </div>
</div>
}
}
export default (props) => (
    <Orderdetails
        {...props}
        params={useParams()}
/>)